import React, { useState } from 'react';
import { Paper, Typography, TextField, Button, Box, Alert, Snackbar } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import EmailTemplate from './EmailTemplate';
import { useTheme } from '@mui/material/styles';

const EmailResults = ({ analysis, businessContext, problemStatement, rawAnswers }) => {
    const theme = useTheme();
    const [email, setEmail] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const emailContent = EmailTemplate({ 
            analysis, 
            businessContext, 
            problemStatement, 
            rawAnswers, 
            theme 
        });

        try {
            const response = await fetch('/send-email.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email,
                    businessContext,
                    problemStatement,
                    rawAnswers,
                    content: emailContent
                })
            });

            if (response.ok) {
                setShowSuccess(true);
                setEmail('');
            } else {
                setShowError(true);
            }
        } catch (error) {
            console.error('Email send error:', error);
            setShowError(true);
        }
    };

    return (
        <Paper 
            sx={{ 
                p: 3, 
                mt: 4, 
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper
            }}
        >
            <Typography 
                variant="h6" 
                gutterBottom 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: theme.palette.text.primary
                }}
            >
                <EmailIcon sx={{ mr: 1 }} />
                Email this Analysis
            </Typography>
            
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    type="email"
                    label="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ 
                        mt: 2,
                        '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                        },
                        '& .MuiOutlinedInput-root': {
                            color: theme.palette.text.primary,
                            '& fieldset': {
                                borderColor: theme.palette.divider
                            }
                        }
                    }}
                    required
                />
                <Button 
                    type="submit"
                    variant="contained"
                    sx={{ mt: 2 }}
                    disabled={!email}
                >
                    Send Analysis
                </Button>
            </form>

            <Snackbar
                open={showSuccess}
                autoHideDuration={6000}
                onClose={() => setShowSuccess(false)}
            >
                <Alert severity="success">Analysis sent successfully!</Alert>
            </Snackbar>

            <Snackbar
                open={showError}
                autoHideDuration={6000}
                onClose={() => setShowError(false)}
            >
                <Alert severity="error">Failed to send email. Please try again.</Alert>
            </Snackbar>
        </Paper>
    );
};

export default EmailResults;